import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally, reveals a success message after copying.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');

    if (!copyContent) return;

    navigator.clipboard.writeText(copyContent);

    const copySuccessMessage = this.refs.copySuccessMessage;

    if (copySuccessMessage instanceof Element) {
      // Handles both a visually-hidden (screen-reader-only) message and a
      // normally-visible one gated by the `hidden` attribute — covers
      // every usage of this component without assuming which pattern a
      // given instance uses.
      copySuccessMessage.classList.remove('visually-hidden');
      copySuccessMessage.hidden = false;
      window.clearTimeout(this._copyConfirmTimeout);
      this._copyConfirmTimeout = window.setTimeout(() => {
        copySuccessMessage.hidden = true;
      }, 2500);
    }
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
